export default __webpack_public_path__ + "static/media/26.65f41db1.jpg";